import { LinkProps } from '@/types/types'

import { MainColumn, MainColumnLeft, MainColumnRight } from '@/components/main-column/MainColumn'

export type StatsItemType = {
  icon?: string | null
  title: string
  text: string
}

export type StatsGridType = {
  columns?: 3 | 4 | 5 | 'text'
  items: StatsItemType[]
  heading?: string
  title?: string
  titleTag?: string
  titleClass?: string
  text?: string
  button?: LinkProps | null
}

export default function StatsGrid({
  columns = 4,
  items = [],
  heading,
  title,
  text,
  button,
}: StatsGridType) {
  if (!items || !items.length) {
    return null
  }

  const componentClass = columns === 'text' ? 'simple-component-wide' : ''

  const hasContent = (columns === 'text' && title) || text

  let gridClass = ''

  if (columns == 5 && items.length >= 5) {
    gridClass = 'grid-cols-1 @[600px]/main:grid-cols-2 @[1240px]/main:grid-cols-5'
  } else if (columns == 4 && items.length >= 4) {
    gridClass = 'grid-cols-1 @[600px]/main:grid-cols-2 @[1240px]/main:grid-cols-4'
  } else {
    gridClass = 'grid-cols-1 @[600px]/main:grid-cols-2 @[1240px]/main:grid-cols-3'
  }

  return (
    <>
      <div className={`component component--stats-grid ${componentClass}`}>
        {hasContent ? (
          <MainColumn>
            <MainColumnLeft
              heading={heading}
              title={title}
              titleTag="h2"
              titleClass="h2"
              text={text}
              button={button}
            />

            <MainColumnRight>
              <div className="@container/main">
                <div className={`grid gap-m ${gridClass}`}>
                  {items.map((item, index) => {
                    const { icon, title, text } = item

                    return <StatsItem key={index} icon={icon} title={title} text={text} />
                  })}
                </div>
              </div>
            </MainColumnRight>
          </MainColumn>
        ) : (
          <div className="container @container/main @[0px]/single-simple:!max-w-[var(--container-s-max-w)]">
            <div className={`grid gap-m ${gridClass}`}>
              {items.map((item, index) => {
                const { icon, title, text } = item

                return <StatsItem key={index} icon={icon} title={title} text={text} />
              })}
            </div>
          </div>
        )}
      </div>
    </>
  )
}

const itemClass = `
  p-s
  @[330px]/item:flex-row
`

const iconClass = `
  aspect-square
  w-[75px]
  @[450px]:w-[85px]
`

export function StatsItem({ icon = null, title, text }: StatsItemType) {
  return (
    <div className="rounded-md bg-theme text-fg @container/item theme--base-0 theme--base-0:border">
      <div className={`flex flex-col items-start gap-m ${itemClass}`}>
        {icon ? (
          <div
            className={`flex-shrink-0 items-center justify-center rounded-md bg-theme p-s text-fg theme--primary-50 ${iconClass}`}>
            <svg className="aspect-square w-full text-primary" aria-hidden="true">
              <use href={`${process.env.NEXT_PUBLIC_SPRITE_ICONS_PATH}#icon-${icon}`}></use>
            </svg>
          </div>
        ) : null}

        <div className="flex flex-col gap-xxs">
          <span className="h5 mb-0 wrap-break-word">{title}</span>

          <div className="p--small style-lists" dangerouslySetInnerHTML={{ __html: text }} />
        </div>
      </div>
    </div>
  )
}
